import React from "react";

import Image from "../Image";

import "./WhyIntensive.css";

export default function WhyIntensive() {
  return (
    <section
      id="nxtwave-vs-others"
      data-sectionid="sections"
      className="wji_ma"
    >
      <div className="wji_ch">
        <div className="wji_h">Why Join NxtWave Intensive?</div>
        <div className="wji_tb">
          <div className="wji_c1">
            <div className="wji_c1_hd" />
            <div className="wji_c1_ea_pa">
              <div className="wji_h_fx">
                <p>Curriculum</p>
              </div>
              <div className="wji_h_fx">
                <p>Doubts Clarification</p>
              </div>
              <div className="wji_h_fx">
                <p>Trainers</p>
              </div>
              <div className="wji_h_fx">
                <p>Placements Record</p>
              </div>
              <div className="wji_h_fx">
                <p>Placements Opportunities</p>
              </div>
              <div className="wji_h_fx">
                <p>Institute Recognised by</p>
              </div>
              <div className="wji_h_fx">
                <p>Projects</p>
              </div>
              <div className="wji_h_fx">
                <p>Access to Labs</p>
              </div>
              <div className="wji_h_fx">
                <p>AI Mock Interviews</p>
              </div>
              <div className="wji_h_fx">
                <p>Expert Mock Interviews</p>
              </div>
              <div className="wji_h_fx">
                <p>Scheduling Interviews</p>
              </div>
              <div className="wji_h_fx">
                <p>
                  Salary Negotiation with <br />
                  Companies
                </p>
              </div>
            </div>
          </div>
          <div className="wji_c2_3">
            <div className="wji_c2">
              <div className="wji_c2_hd_h">NxtWave Intensive</div>
              <div className="wji_h_fx">
                Designed as per companies’ current requirements
              </div>
              <div className="wji_h_fx">
              11AM - 8PM Doubt Clarification
              </div>
              <div className="wji_h_fx">
              NxtWave Certified trainers
              </div>
              <div className="wji_h_fx">
              Proven results for every branch, degree
              </div>
              <div className="wji_h_fx">
                Unlimited from a pool of <br />
                3000+ companies
              </div>
              <div className="wj_c2_3_con_d wji_h_fx">
                <div className="wj_c2_3_t_np">Recognized by</div>
                <div className="wji_c2_3_im_co">
                  <Image
                    className="awards-section-imgs"
                    src="https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/nxtwave-intensive-2.0/pricing-section/pricing-section-nsdc.svg"
                    loading="lazy"
                    alt="pricing-section-nsdc"
                  />
                  <Image
                    className="awards-section-imgs"
                    src="https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/nxtwave-intensive-2.0/pricing-section/pricing-section-nasscom.svg"
                    loading="lazy"
                    alt="pricing-section-nasscom"
                  />
                </div>
              </div>
              <div className="wji_h_fx">
                10+ Real-time Projects that makes your resume strong
              </div>
              <div className="wji_h_fx">
                24x7 Online State-of-the-art Labs. No installation/setup needed.
              </div>
              <div className="wji_h_fx">with NxtMock</div>
              <div className="wji_h_fx">
                with Dedicated Tech &amp; HR Panels
              </div>
              <div className="wj_c2_3_con_d wji_h_fx">
                <Image
                  className="close-and-tick-marks-icons1"
                  src="https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/nxtwave-intensive-2.0/tick-circle.png"
                  alt="tick-circle"
                />
              </div>
              <div className="wj_c2_3_con_d wji_h_fx">
                <Image
                  className="close-and-tick-marks-icons1"
                  src="https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/nxtwave-intensive-2.0/tick-circle.png"
                  alt="tick-circle"
                />
                <div className="wj_c2_3_t_np">For higher salaries</div>
              </div>
            </div>
            <div className="wji_c3">
              <div className="wji_c3_hd_h">Other Coaching Institutes</div>
              <div className="wji_h_fx">Not industry-aligned</div>
              <div className="wji_h_fx">Only 1-2 hours per day</div>
              <div className="wji_h_fx">No real world project experience</div>
              <div className="wji_h_fx">For only select branches, degrees</div>
              <div className="wji_h_fx">Limited (15-20)</div>
              <div className="wji_h_fx">No recognition</div>
              <div className="wji_h_fx">~1-2 real time projects</div>
              <div className="wji_h_fx">Only 2 hours/day</div>
              <div className="wj_c2_3_con_d wji_h_fx">
                <Image
                  className="close-and-tick-marks-icons1"
                  src="https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/nxtwave-intensive-2.0/close-circle.png"
                  alt="close-circle"
                />
              </div>
              <div className="wj_c2_3_con_d wji_h_fx">
                <Image
                  className="close-and-tick-marks-icons1"
                  src="https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/nxtwave-intensive-2.0/close-circle.png"
                  alt="close-circle"
                />
              </div>
              <div className="wj_c2_3_con_d wji_h_fx">
                <Image
                  className="close-and-tick-marks-icons1"
                  src="https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/nxtwave-intensive-2.0/close-circle.png"
                  alt="close-circle"
                />
              </div>
              <div className="wj_c2_3_con_d wji_h_fx">
                <Image
                  className="close-and-tick-marks-icons1"
                  src="https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/nxtwave-intensive-2.0/close-circle.png"
                  alt="close-circle"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
